import {PhasrMonitoredRulesDetailsPanelDataProvider} from "./PhasrMonitoredRulesDetailsPanelDataProvider";
import {API_TYPE_GZ} from "../../../webcomponents.constants";
import {BaseWebComponentDataProviderFactory} from "../../../framework/BaseWebComponentDataProviderFactory";

export class PhasrMonitoredRulesDetailsPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrMonitoredRulesDetailsPanelDataProvider);
  }
}
